import React, {useState, useEffect} from 'react';
import InputText from '../../../../Shared/TextInput/TextInput';
import SelectInput from '../../../../Shared/SelectInput/SelectInput';
import AddressFrm from '../../../../Shared/AddressFrm/AddressFrm';
import {
  goToPage,
  setEquipmentReturnMethod,
  setMobileToPickUp,
  setScheduleDateToDisconnect,
  setDelivery,
  setNotesToPickUp,
  changeMobileHandler,
  setMobileToGetBackTo,
  setDeliveryCodes,
  validateMobileHandler,
} from '../../DisconnectServiceSlice';
import {connect} from 'react-redux';
// import ReactSelect from '../../../../Shared/ReactSelect/ReactSelect';
import {Row, Container} from 'reactstrap';
import {deliveryValidateHandler} from '../../../../Shared/SetUpDeliveries/SetUpDeliveriesSlice';
import Loader from '../../../../Shared/LocalLoader/LocalLoader';
import './DisplayDeliveryWindow';

function DisplayDeliveryWindow(props) {
  const dates = {options: props.slots};
  const keys = dates.options.map((item) => item.key);
  const valid = props.mobileForm.returnToNumberForm.valid;

  function onChange(val) {
    const date = dates.options.find((d) => d.date == val);
    props.setDeliveryCodes(date);
    props.setScheduleDateToDisconnect(val);
  }

  function handleOnError(errorId) {}

  const handleAddressValidate = (isValid) => {};

  useEffect(() => {
    if (props.mobileForm.returnToNumberForm.cellular != '') {
      props.validateMobileHandler(props.mobileForm.returnToNumberForm);
    }
  }, [valid]);

  return (
    <div className='delivery-container'>
      <div className='address-form'>
        <Container>
          <Row style={{color: '#747374'}}>
            <AddressFrm
              title='הזן כתובת לשילוח'
              onError={() => handleOnError()}
              onSubmit={props.isSubmit}
              onValid={() => handleAddressValidate()}
            />
          </Row>
        </Container>
      </div>
      <div className='schedule-form'>
        <h6 className='header'>מועד לאיסוף</h6>
        {props.slots && props.slots.length > 0 ? null : (
          <span style={{fontSize: '0.813rem'}} className='sub-header'>
            יום ושעה מתאימים יאותרו לאחר מילוי הכתובת
          </span>
        )}
        {props.slots.length == 0 &&
        props.addressForm.home &&
        props.addressForm.home != '' &&
        props.deliverySlotsResponseFulfilled === false ? (
          <Loader />
        ) : props.deliverySlotsResponseFulfilled === false ? (
          <SelectInput
            onChange={(e) => onChange(e.target.value)}
            id='pick-up-date'
            defaultText='בחר מועד'
            options={dates.options}
            dataKey={keys}
            dataValue='date'
            name='date'
            required='required'
            disabled
          />
        ) : (
          <SelectInput
            onChange={(e) => onChange(e.target.value)}
            id='pick-up-date'
            defaultText='בחר מועד'
            options={dates.options}
            dataKey={keys}
            dataValue='date'
            name='date'
            required='required'
          />
        )}
      </div>
      <div className='phone-and-deliveryman-form'>
        <h6 className='header'>טלפון והערות</h6>
        <span style={{fontSize: '0.813rem'}} className='sub-header'>
          אפשר להזין כל מספר שנוכל להשיג אותך בו
        </span>
        <InputText
          value={props.mobileForm.returnToNumberForm.cellular}
          onChange={(e) => props.changeMobileHandler({target: e.target, form: props.mobileForm.returnToNumberForm})}
          id='txtInput'
          className='input-phone-txt'
          name='cellular'
          type='text'
          placeholder='נייד'
          error={props.mobileForm.returnToNumberForm.errors.cellular}
        />
        <span style={{fontSize: '0.813rem'}} className='sub-header'>
          חשוב שמי שיפגוש את השליח יהיה מעל גיל 18
        </span>
        <textarea
          maxLength='150'
          className='notes-area'
          onChange={(e) => props.setNotesToPickUp(e.target.value)}
          id='pick-up-notes'
          placeholder='כאן אפשר להוסיף הערות לשליח'></textarea>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  stepParams: state.disconnectServicesBlock.stepParams,
  serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
  UserInfo: state.authentication.loginData.userDetails,
  addressForm: state.addressForm.form,
  mobileForm: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
  slots: state.disconnectServicesBlock.deliverySlotsResponse,
  timeDisconnectScheduled: state.disconnectServicesBlock.summarizeUserDisconnectDetails.timeDisconnectScheduled,
  deliverySlotsResponseFulfilled: state.disconnectServicesBlock.deliverySlotsResponseFulfilled,
});

const mapDispatchToProps = {
  goToPage,
  setEquipmentReturnMethod,
  setMobileToPickUp,
  setScheduleDateToDisconnect,
  setNotesToPickUp,
  changeMobileHandler,
  setMobileToGetBackTo,
  setDelivery,
  deliveryValidateHandler,
  setDeliveryCodes,
  validateMobileHandler,
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayDeliveryWindow);
